<template>
  <div :class="appToolbarItemMenubarClasses">
    <router-link class="link" to="/">
      <AppLogo size="24" />
    </router-link>
    <button :class="menubarClasses" @click="onClickMenubar">
      <div class="line first"></div>
      <div class="line second"></div>
      <div class="line last"></div>
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import AppLogo from '@/app/components/app-logo';

export default defineComponent({
  name: 'AppToolbarItemMenubar',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      //
    };
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      isSidebarActive: 'layout/isSidebarActive',
    }),

    appToolbarItemMenubarClasses() {
      return ['app-toolbar-item', 'menubar'];
    },

    menubarClasses() {
      return ['menubar button basic', { open: this.isSidebarActive }];
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setIsSidebarActive: 'layout/setIsSidebarActive',
    }),

    onClickMenubar() {
      this.setIsSidebarActive(!this.isSidebarActive);
    },
  },

  /**
   * 使用组件
   */
  components: {
    AppLogo,
  },
});
</script>

<style scoped>
@import './styles/app-toolbar-item-menubar.css';
</style>
